import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppActionMenu from '../../../../components/AppActionMenu';

export default function DeductionsTable({
  records = [],
  isLoading = false,
  onDelete,
  onResetFilters,
}) {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-12 text-center shadow-sm">
        <div className="flex flex-col items-center justify-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <p className="text-xs font-semibold text-on-surface-variant">Loading Deductions...</p>
        </div>
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-12 text-center shadow-sm">
        <div className="flex flex-col items-center justify-center gap-3">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-error/10 text-error">
            <span className="material-symbols-outlined text-3xl">money_off</span>
          </div>
          <h3 className="text-lg font-bold text-on-surface">No entries meet selected criteria</h3>
          <p className="text-xs text-on-surface-variant max-w-md">
            Either there are no deduction entries in the system or your current filter criteria matched zero records.
          </p>
          {onResetFilters && (
            <button
              type="button"
              onClick={onResetFilters}
              className="mt-2 rounded-xl bg-primary px-5 py-2 text-xs font-bold text-on-primary shadow-sm hover:bg-primary/90 transition cursor-pointer"
            >
              Reset Filters
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[750px] text-left text-sm">
          <thead>
            <tr className="border-b border-outline-variant/20 bg-surface-container-low/60 text-xs font-bold uppercase tracking-[0.08em] text-on-surface-variant">
              <th className="px-5 py-3.5">Name</th>
              <th className="px-5 py-3.5">Vno</th>
              <th className="px-5 py-3.5">vDate</th>
              <th className="px-5 py-3.5">PayHead</th>
              <th className="px-5 py-3.5 text-right">Amount</th>
              <th className="w-20 px-5 py-3.5 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant/15">
            {records.map((item) => (
              <tr
                key={item.id}
                onClick={() => navigate(`/payroll/deductions/entry/${item.id}`)}
                className="transition-colors hover:bg-surface-container-low/50 cursor-pointer group"
              >
                {/* Employee Name & Code */}
                <td className="px-5 py-3.5 font-bold text-on-surface">
                  <div className="flex flex-col">
                    <span className="font-bold text-on-surface group-hover:text-primary transition-colors">
                      {item.employee}
                    </span>
                    {item.employeeId && (
                      <span className="text-[11px] font-normal text-on-surface-variant">
                        {item.employeeId}
                      </span>
                    )}
                  </div>
                </td>

                {/* Voucher Number */}
                <td className="px-5 py-3.5 text-xs font-mono font-bold text-on-surface-variant">
                  {item.vno || '-'}
                </td>

                {/* Voucher Date */}
                <td className="px-5 py-3.5 text-xs font-medium text-on-surface whitespace-nowrap">
                  {item.vDateDisplay || item.vDate}
                </td>

                {/* PayHead */}
                <td className="px-5 py-3.5 text-xs font-semibold text-error">
                  {item.payHead}
                </td>

                {/* Amount */}
                <td className="px-5 py-3.5 text-right font-bold text-error font-mono">
                  -₹{Number(item.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>

                {/* Actions */}
                <td
                  className="px-5 py-3.5 text-right"
                  onClick={(e) => e.stopPropagation()}
                >
                  <AppActionMenu
                    triggerLabel=""
                    triggerIcon="more_vert"
                    showChevron={false}
                    triggerClassName="rounded-lg p-1.5 text-outline-variant transition-colors hover:bg-surface-container-low hover:text-primary bg-transparent cursor-pointer"
                    items={[
                      { key: 'edit', label: 'Edit', icon: 'edit' },
                      { key: 'delete', label: 'Delete', icon: 'delete', danger: true },
                    ]}
                    onSelect={(key) => {
                      if (key === 'edit') {
                        navigate(`/payroll/deductions/entry/${item.id}`);
                      } else if (key === 'delete') {
                        onDelete?.(item.id, item.employee);
                      }
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
